module.exports = __webpack_public_path__ + "img/stats.f6345406.svg";